import React from 'react';

const ProjectCard = ({ title, description, imgSrc, link }) => {
  return (
    <div className="bg-white shadow-none sm:shadow-md rounded-lg overflow-hidden px-2 sm:px-0 transform-none sm:transform transition-transform duration-300 md:hover:scale-103 md:hover:shadow-lg lg:min-h-[350px] flex flex-col">
      <img
        src={imgSrc}
        alt={`A showcase of the ${title} project.`}
        className="w-full h-64 object-cover"
        // ✅ Changed "lazy" to "eager" to load the image immediately
        loading="eager"
        width="400"
        height="256"
      />
      <div className="p-6 flex-grow flex flex-col">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">{title}</h3>
        <p className="text-gray-600 mb-4 flex-grow">{description}</p>
        {/*<a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 font-medium hover:underline mt-auto"
        >
          View Details
        </a>*/}
      </div>
    </div>
  );
};

export default ProjectCard;